import type { ParticipationState, WinningInfo } from '../../types';

function hasWinningTier(tiers: WinningInfo['tiers']) {
  return tiers.some(tier => tier > 0);
}

function hasLineWinnings(winningLine: WinningInfo | undefined, realWinning?: number) {
  if (!winningLine) return false;

  const hasWinningPerLine = Object.keys(winningLine.winningPerLine ?? {}).length > 0;
  if (hasWinningPerLine) return true;

  const hasRealWinning = (realWinning ?? 0) > 0;
  return hasRealWinning && hasWinningTier(winningLine.tiers);
}

/**
 * Returns whether winnings should be shown for the given lines.
 * A line counts when it has winningPerLine, or when realWinning is present and the line has a winning tier.
 * Never shows when participationState is PENDING.
 */
function shouldShowWinnings(participationState: ParticipationState | undefined, winningLines: WinningInfo[] | undefined, realWinning?: number) {
  if (participationState === 'PENDING') return false;

  return winningLines?.some(line => hasLineWinnings(line, realWinning)) ?? false;
}

export { shouldShowWinnings };
